defaultBillingPeriod